export default __webpack_public_path__ + "static/media/aboutAnimation2.c2bc06c4.png";